import { useContext } from "react";
import useMediaWithInitialState from "~/lib/hooks/useMediaWithInitialState";
import MobileDetectContext from "~/components/MobileDetectContext";

export default function useIsDesktop() {
  const mobileDetectContext = useContext(MobileDetectContext);
  const isDesktop =
    typeof window !== "undefined" ? useMediaWithInitialState("(min-width: 960px)") : mobileDetectContext.isDesktop;
  return isDesktop;
}
